import React, { useEffect } from 'react';
import {
  MuiBox,
  Box,
  Backdrop,
  SvgIconButton,
  Typography,
  Drawer,
  DotProgress,
  Grid,
  color,
  SvgIcon
} from '@kis-technologies/kis-ui';
import { selectors as adminsSelectors, actions as adminsActions } from 'store/admins';
import { format } from 'date-fns';
import { UpdateUserForm } from './UpdateUserForm';
import { UpdateUserDrawerProps } from '../types';
import { useActions } from 'hooks/useActions';
import { useSelector } from 'react-redux';
import { useStyles } from '../styled';

export const UpdateUserDrawer = (props: UpdateUserDrawerProps) => {
  const { isOpen, onClose, admin } = props;
  const { successful, pending } = useSelector(adminsSelectors.selectAction);

  const resetAction = useActions(adminsActions.resetAction);
  const classes = useStyles();

  useEffect(() => {
    if (isOpen && successful) onSuccess();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, successful]);

  const onSuccess = () => {
    onClose();
    resetAction();
  };

  return (
    <>
      {pending && (
        <Backdrop open={pending ? true : false}>
          <DotProgress color={color.GRAY} />
        </Backdrop>
      )}
      <Drawer open={isOpen} onClose={onClose} hasBorderRadius>
        <Grid direction="column" className={classes.updateUserDrawerContainer}>
          <Grid container direction="row" className={classes.drawerAdminNameBlock}>
            <Typography className={classes.updateUserAdminName} sx={{ fontWeight: 600 }}>
              Edit User
            </Typography>
            <MuiBox className={classes.updateDrawerCloseIcon}>
              <SvgIconButton appearance="transparent" onClick={onClose} data-testid="update-user-x">
                <SvgIcon name="exit_circle" size={40} />
              </SvgIconButton>
            </MuiBox>
          </Grid>

          <Box padding="2 6" fullWidth bg="light-gray">
            <Typography fontWeight={600} fontSize={16}>
              {admin.name} Created on {admin.createdAt ? format(new Date(admin.createdAt), 'MMMM dd, yyyy') : ''}
            </Typography>
          </Box>

          <UpdateUserForm admin={admin} />
        </Grid>
      </Drawer>
    </>
  );
};
